

import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import { RadioEventType, RadioPropertyType } from './enums';

export default {
  name: 'Radio',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RadioEventType,
      RadioPropertyType,
    };
  },
  computed: {
    radioClassNames() {
      return new StyleClassNamesBuilder('radio')
        .addClassName(this.className)
        .addConditionClassName('checked', this.checked)
        .addConditionClassName('disabled', this.disabled)
        .build();
    },
  },
  methods: {
    handleChange(event) {
      event.preventDefault();
      this.$emit(RadioEventType.Change, event.target.value);
    },
  },
};
